import { AdobeAnalyticsUtil } from './AdobeAnalyticsUtil.js';

document.addEventListener(
  'toggle',
  (event) => {
    if (event.newState !== 'open') return;

    const information = event.target?.dataset?.tooltipInformation;
    if (!information) return;

    AdobeAnalyticsUtil.DataLayer.TrackEvent('tooltip_open_click', {
      tooltip: { information },
    });
  },
  true
);
